



























import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { ILead } from "@/models/lead.entity";
import { LeadGoToHelper } from "@/lib/utility/lead.go-to-helper";

@Component({
  components: {},
  filters: {}
})
export default class RefsLead extends mixins(Vue) implements IRefDetail<ILead> {
  @Prop()
  item!: ILead;

  @Prop()
  small!: boolean;

  @Prop({ default: false })
  hideLead!: boolean;

  @Prop({ default: false })
  hideDate!: boolean;

  @Prop()
  confirmable!: boolean;

  get date() {
    return simpleDoubleDigitDate(this.item.timestamp.created);
  }

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async goToDetail() {
    const partnerId = this.item.partnerId;
    const leadId = this.item.id;
    const newTab = true;

    new LeadGoToHelper(this.$router).goToLeadDetail({ leadId, partnerId, newTab });
  }
}
